<div
    class="modal fade"
    tabindex="-1"
    [class.show]="visible()"
    [style.display]="visible() ? 'block' : 'none'"
    role="dialog"
    aria-modal="true"
>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ { feature: 'DVI', component: 'Inspection Attachments', label: 'Attachments' } | translate }}</h5>
                <button
                    type="button"
                    class="btn-close"
                    [attr.aria-label]="{ feature: 'Common', component: 'Button', label: 'Close' } | translate"
                    (click)="closed.emit()"
                ></button>
            </div>
            <div class="modal-body">
                @if (canDelete()) {
                    <div class="alert alert-warning d-flex align-items-center py-2" role="alert">
                        <i class="bi bi-exclamation-triangle-fill me-2"></i>
                        <small>{{
                            {
                                feature: 'DVI',
                                component: 'Inspection Attachments',
                                label: 'Deleting an attachment here takes effect immediately and cannot be undone.'
                            } | translate
                        }}</small>
                    </div>
                    @if (popupType() === 'video' && lastTechCheckVideoId()) {
                        <div class="alert alert-info d-flex align-items-center py-2" role="note" data-testid="last-tech-check-video-note">
                            <i class="bi bi-info-circle-fill me-2"></i>
                            <small>{{
                                {
                                    feature: 'DVI',
                                    component: 'Inspection Attachments',
                                    label: 'This is the only Tech Check video, so it cannot be deleted. Reopen for the technician to replace it.'
                                } | translate
                            }}</small>
                        </div>
                    }
                }

                @if ((selectedItem()?.attachments?.length ?? 0) > 0) {
                    <div class="row">
                        @for (file of selectedItem()?.attachments; track $index) {
                            @if (isMediaType()(file.internalName) === popupType()) {
                                <div class="col-6 mb-3">
                                    <div class="position-relative">
                                        @if (popupType() === 'photo') {
                                            <a
                                                href="#"
                                                class="d-block mb-2"
                                                (click)="imagePopupUrl = file.url; showImagePopup = true; $event.preventDefault()"
                                            >
                                                <img [src]="file.url" [alt]="file.name" class="img-fluid img-thumbnail cursor-pointer" />
                                            </a>
                                        } @else if (popupType() === 'video') {
                                            <video [src]="file.url" controls class="h-100 w-100 rounded">
                                                {{
                                                    {
                                                        feature: 'DVI',
                                                        component: 'Inspection Attachments',
                                                        label: 'Your browser does not support the video tag.'
                                                    } | translate
                                                }}
                                            </video>
                                        }

                                        @if (canDelete() && file.id !== lastTechCheckVideoId()) {
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
                                                [title]="({ feature: 'DVI', component: 'Inspection Attachments', label: 'Delete' } | translate) + ' ' + file.name"
                                                (click)="requestDelete(file)"
                                            >
                                                <i class="bi bi-trash"></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                            }
                        }
                    </div>
                }
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closed.emit()">
                    {{ { feature: 'Common', component: 'Button', label: 'Close' } | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

@if (visible()) {
    <div class="modal-backdrop fade show"></div>
}

<div
    class="modal fade"
    tabindex="-1"
    [class.show]="showImagePopup"
    [style.display]="showImagePopup ? 'block' : 'none'"
    role="dialog"
    aria-modal="true"
    style="--image-modal-width: 80vw; --image-modal-height: 80vh;"
>
    <div class="modal-dialog modal-dialog-centered w-100" style="max-width: var(--image-modal-width); height: var(--image-modal-height);">
        <div class="modal-content" style="height: var(--image-modal-height);">
            <div class="modal-header">
                <h5 class="modal-title">{{ { feature: 'DVI', component: 'Inspection Attachments', label: 'Image Preview' } | translate }}</h5>
                <button
                    type="button"
                    class="btn-close"
                    [attr.aria-label]="{ feature: 'Common', component: 'Button', label: 'Close' } | translate"
                    (click)="showImagePopup = false"
                ></button>
            </div>
            <div class="modal-body d-flex align-items-center justify-content-center">
                <img [src]="imagePopupUrl" class="img-fluid" alt="" />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="showImagePopup = false">
                    {{ { feature: 'Common', component: 'Button', label: 'Close' } | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

@if (showImagePopup) {
    <div class="modal-backdrop fade show"></div>
}

@if (pendingDelete(); as file) {
    <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="bi bi-exclamation-triangle-fill text-danger me-2"></i>
                        @if (noun() === 'video') {
                            {{ { feature: 'DVI', component: 'Inspection Attachments', label: 'Delete this video?' } | translate }}
                        } @else {
                            {{ { feature: 'DVI', component: 'Inspection Attachments', label: 'Delete this photo?' } | translate }}
                        }
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        [attr.aria-label]="{ feature: 'Common', component: 'Button', label: 'Close' } | translate"
                        (click)="cancelDelete()"
                    ></button>
                </div>
                <div class="modal-body">
                    <p class="mb-2">
                        @if (noun() === 'video') {
                            {{
                                {
                                    feature: 'DVI',
                                    component: 'Inspection Attachments',
                                    label: 'This video will be permanently deleted. It cannot be recovered.'
                                } | translate
                            }}
                        } @else {
                            {{
                                {
                                    feature: 'DVI',
                                    component: 'Inspection Attachments',
                                    label: 'This photo will be permanently deleted. It cannot be recovered.'
                                } | translate
                            }}
                        }
                    </p>
                    <small class="text-muted d-block text-truncate">{{ file.name }}</small>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="cancelDelete()">
                        {{ { feature: 'DVI', component: 'Inspection Attachments', label: 'Keep it' } | translate }}
                    </button>
                    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
                        <i class="bi bi-trash me-1"></i>
                        @if (noun() === 'video') {
                            {{ { feature: 'DVI', component: 'Inspection Attachments', label: 'Delete video' } | translate }}
                        } @else {
                            {{ { feature: 'DVI', component: 'Inspection Attachments', label: 'Delete photo' } | translate }}
                        }
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
}
